import dedent from 'dedent';

export const smsConsentDef = {
  text: dedent`I agree to receive SMS messages to verify my identity during sign-in.`,
  consentVersionDescription: 'SMS Consent - 1.0',
};
